module.exports = __webpack_public_path__ + "src/img/800k.b11bab51.svg";